import { Box, MasonryGrid, Text } from "designSystem/index";
import { STANDARD_BORDER_STYLE } from "designSystem/styles/style-functions";
import React from "react";

export default () => {
	const imgList = [];

	return (
		<Box
			border={STANDARD_BORDER_STYLE}
			display="inline-block"
			height={200}
			m={4}
			width={300}
		>
			<MasonryGrid
				emptyNode={<Text text="Empty" />}
				imageList={imgList}
			/>
		</Box>
	);
};